/**
 *
 * StudentworkMixin
 *
 */

import { mapMutations, mapActions } from 'vuex';
import $ from 'jquery';

export const OpenStudentworkModalMixin = {
  name: 'OpenStudentworkModalMixin',

  data: () => {
    return {};
  },

  methods: {
    ...mapMutations('Mixins/Studentwork', {
      mm_SET_ASSIGNMENT_ID: 'SET_ASSIGNMENT_ID',
    }),

    ...mapActions('Mixins/Studentwork', {
      ma_getStudentworkList: 'getStudentworkList',
    }),

    //
    noAccessInfo() {
      //
    },

    openStudentworkModal(book) {
      if (!book.c_isCanStudy) {
        this.noAccessInfo(book);
      } else {
        this.mm_SET_ASSIGNMENT_ID(book.studentWorkEntity.assignmentId);
        this.ma_getStudentworkList(book);
        $('#studentwork-modal').modal('show');
      }
    },
  },
};

export default OpenStudentworkModalMixin;
